import { IApplicationState } from '../../types/redux';
import { getUser } from './getUser';

export const selectCanUseHiddenBase = (state: IApplicationState): boolean => {
  const user = getUser(state);

  return user.isAuthenticated && user.permissions.canUseHiddenBase;
};
